import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from '@/config'
import "babel-polyfill"

Vue.config.productionTip = false
Vue.prototype.$config = config
// Vue.prototype.$echarts = echarts
// window.addEventListener('resize', e => { this.getHeight(1); }, false)

router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})